import My2NAppAccessModal from './My2NAppAccessModal';

export default My2NAppAccessModal;
